import { render, staticRenderFns } from "./detecation-items-view.vue?vue&type=template&id=51cda3ca&scoped=true"
import script from "./detecation-items-view.vue?vue&type=script&lang=ts"
export * from "./detecation-items-view.vue?vue&type=script&lang=ts"
import style0 from "./detecation-items-view.vue?vue&type=style&index=0&id=51cda3ca&prod&lang=scss&scoped=true"
import style1 from "./detecation-items-view.vue?vue&type=style&index=1&id=51cda3ca&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51cda3ca",
  null
  
)

export default component.exports